"use client";

import { useState } from "react";

export function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim().includes("@")) setSubmitted(true);
  };

  return (
    <section id="newsletter" className="relative bg-cream py-20 md:py-28 border-t border-ink/8">
      <div className="mx-auto max-w-3xl px-6 text-center">
        <div className="ornament-line mb-6 justify-center">
          <span className="text-gold text-[11px] tracking-[0.35em] uppercase">
            Le Cercle OR
          </span>
        </div>
        <h2 className="font-display text-ink text-4xl md:text-5xl leading-[1.1]">
          Recevez les
          <br />
          <span className="gold-text italic">ventes privées.</span>
        </h2>
        <p className="mt-6 text-ink/65 font-serif text-base md:text-lg leading-relaxed">
          Une lettre hebdomadaire : recettes de chefs français, nouveautés,
          ventes privées et invitations aux dégustations de la cave. Discrétion
          garantie.
        </p>

        {submitted ? (
          <div className="mt-8 inline-flex items-center gap-3 px-6 py-4 rounded-full bg-gold/15 text-gold-dark border border-gold/40">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20 6 9 17l-5-5"></path>
            </svg>
            <span className="text-sm tracking-[0.15em] uppercase">
              Bienvenue dans le Cercle OR
            </span>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="mt-8 max-w-md mx-auto flex flex-col sm:flex-row items-stretch gap-3"
          >
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Votre adresse e-mail"
              className="flex-1 px-5 py-3.5 rounded-full bg-white border border-ink/15 text-ink placeholder:text-ink/40 text-sm focus:outline-none focus:border-gold transition-colors"
            />
            <button
              type="submit"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full gold-gradient text-ink font-semibold tracking-[0.2em] uppercase text-xs gold-shadow hover:scale-[1.02] active:scale-[0.98] transition-transform whitespace-nowrap"
            >
              Rejoindre
            </button>
          </form>
        )}

        <p className="mt-4 text-ink/40 text-[11px] tracking-[0.1em] leading-relaxed max-w-md mx-auto">
          En vous inscrivant, vous acceptez de recevoir la lettre du Cercle OR.
          Désabonnement en un clic.
        </p>
      </div>
    </section>
  );
}
